import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilRepresentante, usuarioPerfilGerente, usuarioPerfilAtendente } from '../usuario/usuario-perfil';


/** Acessos permitidos ao cadastro de itens */
export const acessosItem: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilRepresentante, usuarioPerfilGerente, usuarioPerfilAtendente];

@Injectable()
export class CanActivateItem implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosItem);
    }
}
